import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {Game} from "../Game";
import {gsap} from "gsap";

export class WinCapRunner implements SimplePresentation {
    shouldRun(): boolean {
        return Game.model.gameData.brokeTheBank;
    }

    start(controller: SimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        controller.setSkipCallback(undefined);
        tl.add(Game.winCapView.playWinCapAnimations(() => this.closeCallback(controller)));
        //tl.progress(0.99);
    }

    private closeCallback(controller: SimplePresentationRunnerController): void {
        controller.finish();
    }
}
